@if (!success) {
  <div class="row panel-header">
    <div class="col-md-2"></div>
    <div class="col-md-8">
      <h1>@if (isQaVisible()) {
        <span class="qaText">QA - Umgebung </span>
      }Werden Sie PHOENIX Kunde!</h1>
      <p class="pt-2">
        Wir freuen uns sehr, dass Sie an einer Geschäftsbeziehung mit PHOENIX interessiert sind. Bitte geben Sie
        Ihre
        persönlichen Angaben und die Angaben zu Ihrer Apotheke an. Gerne vereinbaren wir einen persönlichen Termin.
      </p>
      <p>
        Ihre PHOENIX Pharmahandel
      </p>
    </div>
    <div class="col-md-2"></div>
  </div>
}

@if (loading) {
  <div class="row panel-body">
    <div class="col-md-2"></div>
    <div class="col-md-8">
      <spinner message="Ihr Antrag wird übermittelt."></spinner>
    </div>
    <div class="col-md-2"></div>
  </div>
}

@if (success) {
  <message message="Ihr Antrag wurde erfolgreich übermittelt. Wir werden uns in Kürze bei Ihnen melden.">
  </message>
}
@if (error) {
  <notification type="error" [message]="error"></notification>
}

@if (!loading && !success) {
  <div class="row panel-body mb-xxxl">
    <div class="col-md-2"></div>
    <div class="col-md-8">
      <form [formGroup]="userForm" [class.submitted]="submitted">
        <div class="row">
          <div class="col-md-6">
            <h4>Persönliche Angaben</h4>
            <div>
              <mat-form-field appearance="outline">
                <mat-label>Anrede</mat-label>
                <mat-select [formControlName]="'salutation'">
                  @for (salutation of ['Herr', 'Frau']; track salutation) {
                    <mat-option [value]="salutation">
                      {{salutation}}
                    </mat-option>
                  }
                </mat-select>
                @if (salutation.hasError('required') && submitted) {
                  <mat-error>Bitte wählen Sie eine Anrede
                  </mat-error>
                }
              </mat-form-field>
            </div>
            <div>
              <mat-form-field appearance="outline">
                <mat-label>Titel - optional</mat-label>
                <input matInput autocomplete="off" name="title" formControlName="title">
              </mat-form-field>
            </div>
            <div>
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Vorname</mat-label>
                <input matInput autocomplete="off" name="firstName" formControlName="firstName">
                @if (firstName.hasError('required') && submitted) {
                  <mat-error>Bitte geben Sie Ihren
                    Vornamen ein.
                  </mat-error>
                }
              </mat-form-field>
            </div>
            <div>
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Nachname</mat-label>
                <input matInput autocomplete="off" name="lastName" formControlName="lastName">
                @if (lastName.hasError('required') && submitted) {
                  <mat-error>Bitte geben Sie Ihren
                    Nachnamen ein.
                  </mat-error>
                }
              </mat-form-field>
            </div>
          </div>
          <div class="col-md-6">
            <h4>Angaben zur Apotheke</h4>
            <div>
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Name der Apotheke</mat-label>
                <input matInput autocomplete="off" name="apotheke" formControlName="name">
                @if (name.hasError('required') && submitted) {
                  <mat-error>Bitte geben Sie den Namen Ihrer
                    Apotheke ein.
                  </mat-error>
                }
              </mat-form-field>
            </div>
            <div>
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>IDF-Nummer</mat-label>
                <input matInput autocomplete="off" name="idf" formControlName="idf">
                @if (idf.hasError('required') && submitted) {
                  <mat-error>Bitte geben Sie Ihre IDF-Nummer
                  ein.</mat-error>
                }
                @if (idf.hasError('pattern') && submitted) {
                  <mat-error>Geben Sie eine 7-stellige
                  Zahlenfolge ein.</mat-error>
                }
              </mat-form-field>
            </div>
            <div>
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Straße und Hausnummer</mat-label>
                <input matInput autocomplete="off" name="street" formControlName="street">
                @if (street.hasError('required') && submitted) {
                  <mat-error>Bitte geben Sie Straße und
                    Hausnummer Ihrer
                    Apotheke ein.
                  </mat-error>
                }
              </mat-form-field>
            </div>
            <div>
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>PLZ</mat-label>
                <input matInput autocomplete="off" name="zipCode" formControlName="zipCode">
                @if (zipCode.hasError('required') && submitted) {
                  <mat-error>Bitte geben Sie Postleitzahl
                    ihrer Apotheke
                    ein.
                  </mat-error>
                }
                @if (zipCode.hasError('pattern') && submitted) {
                  <mat-error>Ihre Postleitzahl muss 5 Ziffern
                    lang sein.
                  </mat-error>
                }
              </mat-form-field>
            </div>
            <div>
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Ort</mat-label>
                <input matInput autocomplete="off" name="city" formControlName="city">
                @if (city.hasError('required') && submitted) {
                  <mat-error>Bitte geben Sie den Ort ihrer
                    Apotheke ein.
                  </mat-error>
                }
              </mat-form-field>
            </div>
            <div>
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>E-Mail</mat-label>
                <input matInput autocomplete="off" name="email" formControlName="email" type="email">
                @if (email.hasError('required') && submitted) {
                  <mat-error>Bitte geben Sie Ihre
                    E-Mail-Adresse ein.
                  </mat-error>
                }
                @if (email.hasError('pattern') && submitted) {
                  <mat-error>Bitte geben Sie eine gültige
                    E-Mail-Adresse ein.
                  </mat-error>
                }
              </mat-form-field>
            </div>
            <div>
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Telefonnummer</mat-label>
                <input matInput autocomplete="off" name="phone" formControlName="phone">
                @if (phone.hasError('required') && submitted) {
                  <mat-error>Bitte geben Sie die Telefonnummer
                    Ihrer
                    Apotheke ein.
                  </mat-error>
                }
                @if (phone.hasError('pattern') && submitted) {
                  <mat-error>Bitte geben Sie eine gültige
                  Telefonnummer ein.</mat-error>
                }
              </mat-form-field>
            </div>
            <div>
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Faxnummer - optional</mat-label>
                <input matInput autocomplete="off" name="fax" formControlName="fax">
                @if (fax.hasError('pattern') && submitted) {
                  <mat-error>Bitte geben Sie eine gültige
                  Faxnummer ein.</mat-error>
                }
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 text-left">
            <a routerLink="/login">
              <button class="btn btn-secondary">Zurück zum Login</button>
            </a>
          </div>
          <div class="col-md-6 text-right">
            <button class="btn btn-primary" (click)="submit()">Anfrage senden</button>
          </div>
        </div>
      </form>
    </div>
    <div class="col-md-2"></div>
  </div>
}
